<template>
  <div class="domain-graph-page">
    <div class="domain-graph-header">
      <div class="flex items-center space-x-3 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-10 h-10 text-green-600">
          <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
          <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
          <path d="M3 12A9 3 0 0 0 21 12"></path>
        </svg>
        <div>
          <h1 class="text-3xl font-bold text-gray-900">Domain Graph System</h1>
          <p class="text-gray-600">Intelligent data analysis and natural language querying</p>
        </div>
      </div>

      <div v-if="stats" class="grid grid-cols-4 gap-4 mb-6">
        <div class="bg-white rounded-lg shadow p-4">
          <div class="text-sm text-gray-600">Documents</div>
          <div class="text-2xl font-bold text-green-600">{{ stats.total_documents }}</div>
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <div class="text-sm text-gray-600">Entities</div>
          <div class="text-2xl font-bold text-green-600">{{ stats.total_entities }}</div>
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <div class="text-sm text-gray-600">Relationships</div>
          <div class="text-2xl font-bold text-green-600">{{ stats.total_relationships }}</div>
        </div>
        <div class="bg-white rounded-lg shadow p-4">
          <div class="text-sm text-gray-600">Entity Types</div>
          <div class="text-2xl font-bold text-green-600">{{ Object.keys(stats.entity_types || {}).length }}</div>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-xl shadow-lg overflow-hidden">
      <div class="border-b border-gray-200">
        <nav class="flex">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            @click="activeTab = tab.id"
            :class="[
              'flex items-center space-x-2 px-6 py-4 font-medium transition-colors',
              activeTab === tab.id
                ? 'border-b-2 border-green-600 text-green-600'
                : 'text-gray-600 hover:text-gray-900'
            ]"
          >
            <component :is="tab.icon" class="w-5 h-5" />
            <span>{{ tab.label }}</span>
          </button>
        </nav>
      </div>

      <div class="p-6">
        <query-interface v-if="activeTab === 'query'" />
        <schema-viewer v-if="activeTab === 'schema'" />
        <entity-browser v-if="activeTab === 'entities'" />
        <file-upload v-if="activeTab === 'upload'" @upload-complete="fetchStats" />
        <statistics v-if="activeTab === 'statistics'" :stats="stats" />
      </div>
    </div>
  </div>
</template>

<script>
import QueryInterface from '../components/DomainGraph/QueryInterface.vue';
import EntityBrowser from '../components/DomainGraph/EntityBrowser.vue';
import SchemaViewer from '../components/DomainGraph/SchemaViewer.vue';
import FileUpload from '../components/DomainGraph/FileUpload.vue';
import Statistics from '../components/DomainGraph/Statistics.vue';

export default {
  name: 'DomainGraphPage',
  
  components: {
    QueryInterface,
    EntityBrowser,
    SchemaViewer,
    FileUpload,
    Statistics
  },
  
  data() {
    return {
      activeTab: 'query',
      stats: null,
      tabs: [
        { id: 'query', label: 'Query', icon: 'SearchIcon' },
        { id: 'schema', label: 'Schema', icon: 'DatabaseIcon' },
        { id: 'entities', label: 'Entities', icon: 'NetworkIcon' },
        { id: 'upload', label: 'Upload', icon: 'UploadIcon' },
        { id: 'statistics', label: 'Statistics', icon: 'ChartIcon' }
      ]
    };
  },
  
  mounted() {
    this.fetchStats();
  },
  
  methods: {
    async fetchStats() {
      try {
        const response = await this.$axios.get('/api/domain-graph/stats');
        this.stats = response.data;
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    }
  }
};
</script>

<style scoped>
.domain-graph-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
}

.domain-graph-header {
  margin-bottom: 24px;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.space-x-3 > * + * {
  margin-left: 0.75rem;
}

.space-x-2 > * + * {
  margin-left: 0.5rem;
}

.gap-4 {
  gap: 1rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.grid {
  display: grid;
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
</style>
